import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface TransactionListStoppedAtHeaderProps
  extends HeaderContext<TransactionModel, TransactionModel['stoppedAt']> {}

export const TransactionListStoppedAtHeader =
  (): // props: TransactionListStoppedAtHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-transaction.stopped-at');
  };
